import { Checkbox, FormControlLabel, SxProps, Typography } from '@mui/material';
import SquareCheckboxIcon from '../../../../../../components/Profile/SquareCheckbox/SquareCheckboxIcon';

interface CheckBoxProps {
  sx?: SxProps;
  label: string;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

const CheckBox = ({ sx, label, onChange, checked = false }: CheckBoxProps) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={onChange}
          sx={{ padding: 0, margin: 0 }}
          icon={<SquareCheckboxIcon />}
          checkedIcon={<SquareCheckboxIcon checked />}
        />
      }
      label={
        <Typography
          variant={'caption'}
          sx={{
            fontWeight: 400,
            fontSize: '14px',
            '&:first-letter': { textTransform: 'capitalize' },
          }}
        >
          {label}
        </Typography>
      }
      sx={{
        padding: '9px 0',
        margin: 0,
        gap: '12px',
        width: '100%',
        alignItems: 'center',
        ...sx,
      }}
    />
  );
};

export default CheckBox;
